import WebLayout from './PaginationWrapper.web';
import MobileLayout from './PaginationWrapper.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;
